import { render } from "./ChangeNetwork.vue?vue&type=template&id=6fa502d0&scoped=true"
import script from "./ChangeNetwork.vue?vue&type=script&lang=ts"
export * from "./ChangeNetwork.vue?vue&type=script&lang=ts"

import "./ChangeNetwork.vue?vue&type=style&index=0&id=6fa502d0&scoped=true&lang=less"
import "./ChangeNetwork.vue?vue&type=style&index=1&id=6fa502d0&lang=less"
script.render = render
script.__scopeId = "data-v-6fa502d0"

export default script